// eslint-disable

export const recStart = `mutation RecStart($organizationId: ID!, $input: [RecStartInput]!) {
  recStart(organizationId: $organizationId, input: $input) {
    error
    result
  }
}
`
export const recStop = `mutation RecStop($organizationId: ID!, $input: [ID]!) {
  recStop(organizationId: $organizationId, input: $input) {
    error
    result
  }
}
`
export const shutdown = `mutation Shutdown($organizationId: ID!, $input: [ID]!) {
  shutdown(organizationId: $organizationId, input: $input) {
    error
    result
  }
}
`
export const reboot = `mutation Reboot($organizationId: ID!, $input: [ID]!) {
  reboot(organizationId: $organizationId, input: $input) {
    error
    result
  }
}
`
export const setAssign = `mutation SetAssign($organizationId: ID!, $input: SetAssignInput!) {
  setAssign(organizationId: $organizationId, input: $input) {
    error
    result
  }
}
`
